const state = {
    select: null // 当前选中的组件key
};

// getters
const getters = {
    select: state => state.select,
};

// mutations
const mutations = {
    selectControl(state, control) {
        state.select = control;
    },
};

const actions = {
};

export default {
    state,
    getters,
    mutations,
    actions
}
